import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, validPhone } from '../../constants/globalConstants'
import { useNavigate } from 'react-router-dom'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { useForm, Controller } from 'react-hook-form'
import { Circles } from 'react-loader-spinner'
import { Form } from 'react-bootstrap'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import 'react-toastify/dist/ReactToastify.css'
import './modalLogin.scss'
import { userLogin, userSingUp } from '../../redux/actions/login'
import URL from '../../constants/urls'
import { getConfigDetails } from '../../services/config'
import { getVehicleDetailsList, getVehicleModelList } from '../../redux/actions/VehicleListAction'

import { restrictInValidCharPassword, validatePassword, sortPortalPermissionByKey, isPermissionExist, restrictSpecialChar, restrictInputValues, trimObjectValues, encodePasswordBase } from '../../utils/helper'

// ===== reCAPTCHA v3 Import =====
import useRecaptcha from '../../Hooks/useRecaptcha'
// ===== End reCAPTCHA Import =====
import useOtpVerification from '../../Hooks/useOtpVerification'


function ModalLogin(props) {
    const { setShow, show, dispatch, notify, useFor, stateData, countryData, partnerDetails } = props
    const { register, handleSubmit, formState: { errors }, control, reset, setValue, getValues } = useForm()
    const handleClose = () => {
        setShow(false)
        setModalSignup(0)
        resetOtp()
    }
    const navigate = useNavigate()
    const partner = window.location.toString().split('/')[3]
    const iframePartner = window.location.toString().split('/')[4]
    const [modalSingup, setModalSignup] = useState(0)
    const [passwordShown, setPasswordShown] = useState(false)
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [stateList, setStateList] = useState(stateData)
    const [error, setError] = useState({ password_strength: false, confirm_password_strength: false })
    const [accessPermissions, setAccessPermissions] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    // ===== reCAPTCHA v3 Hook =====
    const { getToken, isReady } = useRecaptcha()
    // ===== End reCAPTCHA Hook =====

    // ─── OTP Hook ─────────────────────────────────────────────────────
    const {
        otp, otpSent, otpLoading, otpError, otpSentFor, resendCooldown,
        canResend, resendLimitReached, handleOtpChange, handleSendOtp,
        handleResendOtp, resetOtp, checkIdentifierChange
    } = useOtpVerification({ process: 'signup' })
    // ──────────────────────────────────────────────────────────────────

    useEffect(() => {
        setModalSignup(useFor ? Number(useFor) : 0)
    }, [useFor])
    useEffect(() => {
        if (partnerDetails?.id) {
            let countryList = [partnerDetails?.facilities?.[0]?.country_code, 'CA', 'GB']
            if (isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode')) {
                countryList = [partnerDetails?.facilities?.[0]?.country_code, 'CA', 'GB']
            }
            dispatch(getVehicleDetailsList(countryList)).then(() => {
                let defaultCountry = countryData ? countryData?.[1]?.name : 'United States'
                setValue('country', defaultCountry)
                getStateByCountry(defaultCountry)
            })
        }
    }, [EMPTY_ARRAY, partnerDetails, show])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])



    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setPasswordShown(passwordShown ? false : true)
        }
        if (key === 'mpassword') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }

    const handleInputChange = (e) => {
        let formValue = getValues()?.[e.target.name]
        setValue(e.target.name, restrictInValidCharPassword(formValue))
        const { name } = e.target
        if (name == 'password') {
            setError({ ...error, password_strength: false })
        } else {
            setError({ ...error, confirm_password_strength: false })
        }
    }

    // ─── Watch email/phone changes to invalidate OTP if changed ───────
    const notifyIdentifierChange = (changed) => {
        if (!changed) return
        notify('error', 'Your email/phone has changed. Please request a new OTP.')
    }

    const handleEmailChange = () => {
        const currentPhone = getValues('phone')
        setTimeout(() => {
            notifyIdentifierChange(checkIdentifierChange(getValues('email'), currentPhone))
        }, 0)
    }

    const handlePhoneChangeForOtp = (value) => {
        const currentEmail = getValues('email')
        setTimeout(() => {
            notifyIdentifierChange(checkIdentifierChange(currentEmail, value))
        }, 0)
    }
    // ──────────────────────────────────────────────────────────────────

    const handleSecondModal = () => {
        reset(formValues => ({
            ...formValues,
            username: '',
            password: ''
        }))
        resetOtp()
        setModalSignup(1)
        // setBackButtonHide(true)
    }


    const onSignIn = async (formData) => {
        setIsLoading(true)
        const data = trimObjectValues(formData)
        Object.keys(data).filter(key => {
            if (data[key] == undefined) {
                setValue(key, undefined)
            }
        })
        if (data?.username !== '' && data?.password !== '') {

            // ===== reCAPTCHA v3: Generate Token for Login =====
            const recaptcha_token = await getToken('login')
            if (!recaptcha_token) {
                notify('error', 'Security verification failed. Please try again.')
                setIsLoading(false)
                return
            }
            // ===== End reCAPTCHA =====

            const payloadKeys = { 'client_id': getConfigDetails()?.CLIENT_ID, 'client_secret': getConfigDetails()?.CLIENT_SECRET, 'grant_type': 'password' }
            let ecryptedPassword = encodePasswordBase(data?.password)
            data.password = ecryptedPassword
            const finalPayload = { ...payloadKeys, ...data, recaptcha_token }
            finalPayload.booking_label_id = partnerDetails?.brand_setting ? partnerDetails?.brand_setting?.user_id : ''
            dispatch(userLogin(finalPayload)).then((res) => {
                setIsLoading(false)
                if (res?.status === 201 && res?.data !== null) {
                    localStorage?.setItem('userData', JSON.stringify(res?.data))
                    localStorage?.setItem('access_token', JSON.stringify(res?.data?.access_token))
                    notify('success', 'User Login Successfully')
                    // setIsLogin(true)
                    setShow(false)
                    reset(formValues => ({
                        ...formValues,
                        'username': '',
                        'password': '',
                    }))
                    navigate(`/${partner}${URL?.BASE_USER}`)
                    //navigate(`${URL?.BASE_USER}`)
                    //window. location. reload(true)
                    // navigate(0)
                } else {
                    // setIsLogin(false)
                    notify('error', res?.errors?.message)
                }
            }).catch((errors) => {
                setIsLoading(false)
                notify('error', errors?.message)
                // setIsLogin(false)
            })
        }
    }

    // Signup form submit. Step 1 (before OTP is sent): send OTP and reveal the
    // OTP field. Step 2 (OTP already sent): call the signup API with the OTP.
    const onSignupFormSubmit = async (formData) => {
        const data = trimObjectValues(formData)
        Object.keys(data).filter(key => {
            if (data[key] == undefined) {
                setValue(key, undefined)
            }
        })

        if (!validatePassword(data?.password)) {
            setError({ ...error, password_strength: true })
            return
        } else if (!validatePassword(data?.cpassword)) {
            setError({ ...error, confirm_password_strength: true })
            return
        }

        if (data?.password !== data?.cpassword) {
            notify('error', 'Password not match')
            return
        }

        if (otpSent) {
            await handleSignup(data)
            return
        }

        setIsLoading(true)
        handleSendOtp(data?.email, data?.phone).then((ok) => {
            setIsLoading(false)
            if (ok) {
                notify('success', 'OTP sent successfully.')
            }
        })
    }

    const handleResendOtpClick = () => {
        const email = getValues('email')
        const phone = getValues('phone')
        handleResendOtp(email, phone)
    }

    // Step 2: submit signup API with OTP
    const handleSignup = async (data) => {
        if (!otp || otp.length !== 6) {
            notify('error', 'Please enter the 6-digit OTP.')
            return
        }

        // If email/phone were changed after the OTP was sent, force a resend.
        if (
            !otpSentFor ||
            (otpSentFor.email || '') !== (data?.email || '') ||
            (otpSentFor.phone || '') !== (data?.phone || '')
        ) {
            notify('error', 'Email or phone changed. Please resend the OTP.')
            return
        }

        setIsLoading(true)

        // ===== reCAPTCHA v3: Generate Token for Registration =====
        const recaptcha_token = await getToken('signup')
        if (!recaptcha_token) {
            notify('error', 'Security verification failed. Please try again.')
            setIsLoading(false)
            return
        }
        // ===== End reCAPTCHA =====

        const payload = {
            'first_name': '',
            'last_name': '',
            'email': '',
            'phone': '',
            'confirm_password': '',
            'client_secret': getConfigDetails()?.CLIENT_SECRET,
            'base_url': `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalBASEURL : getConfigDetails()?.portalBASEURL}/${partner != 'iframe' ? partner : iframePartner}`
            // 'base_url': `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.transientURL : getConfigDetails()?.transientURL}/${partner}/${pushBack?.route}/${pushBack?.facility}`
        }
        const finalPayload = { ...payload, ...data, recaptcha_token, otp }
        finalPayload['confirm_password'] = encodePasswordBase(finalPayload?.cpassword)
        delete finalPayload?.password
        delete finalPayload?.cpassword
        delete finalPayload?.username
        finalPayload.booking_label_id = partnerDetails?.brand_setting ? partnerDetails?.brand_setting?.user_id : ''

        dispatch(userSingUp(finalPayload)).then(async (res) => {
            setIsLoading(false)
            if (res?.status === 201) {
                localStorage?.setItem('userData', JSON.stringify(res?.data))
                localStorage?.setItem('access_token', JSON.stringify(res?.data?.access_token))
                notify('success', 'Registration Successfully Completed')
                resetOtp()

                // ===== reCAPTCHA v3: Fresh Token for Auto-Login after Signup =====
                const loginCaptchaToken = await getToken('login')
                // ===== End reCAPTCHA =====

                const payloadKeys = { 'client_id': getConfigDetails()?.CLIENT_ID, 'client_secret': getConfigDetails()?.CLIENT_SECRET, 'grant_type': 'password' }

                payloadKeys.username = data?.email
                payloadKeys.password = encodePasswordBase(data?.password)
                if (loginCaptchaToken) {
                    payloadKeys.recaptcha_token = loginCaptchaToken
                }
                payloadKeys.booking_label_id = partnerDetails?.brand_setting ? partnerDetails?.brand_setting?.user_id : ''
                dispatch(userLogin(payloadKeys)).then((res) => {
                    const userData = res?.data

                    if (userData) {
                        localStorage.setItem('isLoggedIn', true)
                        localStorage.setItem('userData', JSON.stringify(userData))
                        navigate(`/${partner}${URL?.BASE_USER}`)

                        //navigate(`${URL?.BASE_USER}`)
                        // window. location. reload(true)

                    } else {
                        notify(res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                    }

                }).catch((err) => {
                    const response = err?.errors

                    notify(response?.message ? response?.message : 'Something went wrong, Please try again!')

                })

                // setIsLogin(true)
                setShow(false)
                reset(formValues => ({
                    ...formValues,
                    'first_name': '',
                    'last_name': '',
                    'email': '',
                    'phone': '',
                    'confirm_password': '',
                    'client_secret': getConfigDetails()?.CLIENT_SECRET
                }))
                navigate(`/${partner}${URL?.BASE_HOME}`)

                // navigate(0)
            } else {
                // setIsLogin(false)
                notify('error', res?.errors?.message)
            }
        }).catch(() => {
            setIsLoading(false)
            notify('error', 'Something went wrong!')
            // setSignInModal(true)
        })
    }

    const handlecountryChange = (e) => {
        const { value } = e.target
        getStateByCountry(value)
        setValue('zipcode', '')
    }
    const getStateByCountry = (value) => {
        let countryDatas = countryData?.filter((v) => v.name == value)
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryDatas?.[0]?.id)).then((res) => {
            setStateList(res?.state)

            setValue('country', value)
        })

    }

    const handleBackButton = () => {
        reset(formValues => ({
            ...formValues,
            email: '',
            phone: '',
            first_name: '',
            cpassword: '',
            password: '',
        }))
        resetOtp()
        setModalSignup(0)
    }

    const handleForgotPassword = () => {
        navigate(`/${partner}${URL?.BASE_SEND_EMAIL_FORGOT_PASSWORD}`)
        setShow(false)

    }

    return (
        <>
            <Modal show={show} size={modalSingup === 1 ? 'lg' : null} onHide={handleClose} backdrop={otpSent ? 'static' : true} keyboard={otpSent ? false : true}>
                {modalSingup === 0 &&
                    <form onSubmit={handleSubmit(onSignIn)}>
                        <Modal.Header closeButton> <Modal.Title>Login</Modal.Title> </Modal.Header>
                        <Modal.Body   >
                            <div className="mb-3">
                                <label htmlFor="exampleInputEmail1" className="form-label">User Name <span style={{ color: 'red' }}>*</span></label>
                                <input type="email" name='username' className="form-control" maxLength='40' minLength='1' placeholder="" {...register('username', {
                                    required: true,
                                    message: 'Name is required',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'invalid email address'
                                    },
                                    validate: (value) => value.trim() !== ''
                                })} />
                                {errors?.username && <span style={{ color: 'red' }}>This field is required</span>}
                                {errors?.username?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.username?.message}</span>}
                            </div>

                            <div className="mb-3 myiconset">
                                <label htmlFor="exampleInputPassword1" className="form-label">Password <span style={{ color: 'red' }}>*</span>
                                    <span className="popoverSection position-relative"  >
                                        <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                        <i
                                            className="fa fa-question-circle "
                                        >
                                        </i>
                                    </span>
                                </label>
                                <input type={passwordShown ? 'text' : 'password'}
                                    name='password'
                                    className="form-control passwordInput"
                                    id="exampleInputPassword1" {...register('password', {
                                        required: true,
                                        message: 'Name is required'
                                    })}
                                    minLength={8}
                                    maxLength={15} />
                                <i className={passwordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                {errors?.password && <span style={{ color: 'red' }}>This field is required</span>}
                            </div>
                            <div className='mb-3 cursor' >
                                <span className="form-label" onClick={() => { handleForgotPassword() }}>Forgot Password? </span>

                            </div>

                            <div className="mb-3">
                                {/* ===== reCAPTCHA: disabled when not ready ===== */}
                                <Button variant="primary" type='submit' disabled={isLoading || !isReady} className="btn btn-primary btn-lg w-100" onClick={handleSubmit}>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <span>Sign in </span>  <span className='ms-2'>
                                            {isLoading ? <Circles
                                                height="20"
                                                width="20"
                                                style={{ display: 'inline-block' }}
                                                color="#ffffff"
                                                ariaLabel="circles-loading"
                                                visible={true}
                                            /> : null}
                                        </span>
                                    </div>
                                </Button>
                            </div>
                            <div className="mb-3 text-center">
                                New on our platform? <a type='button' className='text-primary' role='button' onClick={handleSecondModal}>Create an account</a>
                            </div>
                        </Modal.Body>
                    </form>
                }
                {modalSingup === 1 &&
                    <form onSubmit={handleSubmit(onSignupFormSubmit)}>
                        <Modal.Header closeButton> <Modal.Title>Register your Account</Modal.Title></Modal.Header>
                        <Modal.Body className="pb-5"  >
                            <div className="checkinForm">
                                <h6 className='text-muted fw-semibold'>Login Info</h6>
                                <div className='row'>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                            <input type="email" name='email' className="form-control" maxLength='40' minLength='1' placeholder="Enter your email" {...register('email', {
                                                required: true,
                                                message: 'Name is required',
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: 'invalid email address'
                                                },
                                                validate: (value) => value.trim() !== '',
                                                onChange: handleEmailChange,
                                            })} />
                                        </div>
                                        {errors?.email && <span className="text-danger small">This field is required</span>}
                                        {errors?.email?.type === 'pattern' && <span className="text-danger small">{errors?.email?.message}</span>}
                                    </div>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Phone <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="phone"
                                                type="text"
                                                id="phone"
                                                control={control}
                                                rules={{
                                                    required: true,
                                                    message: 'Phone is required',
                                                    minLength: {
                                                        value: 10,
                                                        message: 'Minimum 10 characters allowed',
                                                    },
                                                    pattern: {
                                                        value: validPhone,
                                                        message: 'Please enter a valid phone number',
                                                    },
                                                    validate: (value) => value.trim() !== ''
                                                }}
                                                render={({ field }) => <MaskedInput
                                                    maskGenerator={phoneMaskGenerator}
                                                    className="form-control"
                                                    {...field}
                                                    onChange={(val) => {
                                                        field.onChange(val)
                                                        handlePhoneChangeForOtp(val)
                                                    }}
                                                    maxLength={14}
                                                    title="Please enter a valid phone number"
                                                    onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    placeholder="Phone Number"
                                                />}
                                            />
                                        </div>
                                        {errors?.phone && <span className="text-danger small">{errors?.phone?.message}</span>}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6 myiconset">
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Password <span style={{ color: 'red' }}>*</span>
                                                <span className="popoverSection position-relative"  >
                                                    <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                    <i
                                                        className="fa fa-question-circle "
                                                    >
                                                    </i>
                                                </span></label>
                                            <input className="form-control  passwordInput"
                                                name="password" placeholder="Create Password"
                                                {...register('password', {
                                                    required: true,
                                                    message: 'Name is required',
                                                    onChange: (e) => handleInputChange(e)
                                                })}
                                                type={mpasswordShown ? 'text' : 'password'} />
                                        </div>
                                        <i className={mpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'mpassword')}></i>
                                        {errors?.password && <span className="text-danger small">This field is required</span>}
                                        {(error?.password_strength) && <Form.Text className="text-danger">Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</Form.Text>}
                                    </div>
                                    <div className="col-sm-6 myiconset">
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Confirm Password <span className="text-danger small">*</span>
                                                <span className="popoverSection position-relative"  >
                                                    <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                    <i
                                                        className="fa fa-question-circle "
                                                    >
                                                    </i>
                                                </span>
                                            </label>
                                            <input className="form-control  passwordInput"
                                                {...register('cpassword', {
                                                    required: true,
                                                    message: 'Name is required',
                                                    onChange: (e) => handleInputChange(e)
                                                })}
                                                name="cpassword" placeholder="Confirm Password"
                                                type={cpasswordShown ? 'text' : 'password'} />
                                        </div>
                                        <i className={cpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                                        {errors?.cpassword && <span className="text-danger small">This field is required</span>}
                                        {(error?.confirm_password_strength) && <Form.Text className="text-danger small">Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</Form.Text>}
                                    </div>
                                </div>
                                <hr />
                                <h6 className='text-muted fw-semibold'>Contact Info</h6>
                                <div className='row row-cols-sm-2 row-cols-1'>
                                    <div className='col'>
                                        <div className="mb-2">
                                            <label htmlFor="" className="form-label">First Name <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" className="form-control" name='first_name' id="first_name" placeholder="Enter First Name"
                                                {...register('first_name', {
                                                    required: true,
                                                    message: 'Name is required',
                                                    validate: (value) => value.trim() !== ''
                                                })} />
                                            {errors?.first_name && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className="mb-2">
                                            <label htmlFor="" className="form-label">Last Name <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='last_name' className="form-control" id="last_name" placeholder="Enter Last Name"
                                                {...register('last_name', {
                                                    required: true,
                                                    message: 'Name is required',
                                                    validate: (value) => value.trim() !== ''
                                                })} />
                                            {errors?.last_name && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Company Name</label>
                                            <input type="text" name='company_name' className="form-control" id="company_name" placeholder="Enter Company Name" {...register('company_name')} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Address 1 <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='address1' className="form-control" id="address1" placeholder="Enter Address 1" {...register('address1', {
                                                required: true,
                                                message: 'Name is required',
                                                validate: (value) => value.trim() !== ''
                                            })} />
                                            {errors?.address1 && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Address 2</label>
                                            <input type="text" name='address2' className="form-control" id="address2" placeholder="Enter Address 2" {...register('address2')} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">City <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='city' className="form-control" id="city" placeholder="Enter City" {...register('city', {
                                                required: true,
                                                message: 'Name is required',
                                                validate: (value) => value.trim() !== ''
                                            })} />
                                            {errors?.city && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Country <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="country"
                                                id='country'
                                                control={control}
                                                defaultValue=""
                                                className='form-select'
                                                rules={{
                                                    required: true,
                                                    message: 'Name is required',
                                                }}
                                                render={({ field }) => <select type="select" className='form-select' name='country' id='country' {...field} onChange={(e) => { field.onChange(e); handlecountryChange(e) }}>
                                                    <option value=''>Select Country</option>
                                                    {countryData?.map((item, index) => <option key={(index + 1)} value={item?.name} >{item?.name}</option>)}
                                                </select>}
                                            />
                                            {errors?.country && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">State <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="state"
                                                id='state'
                                                control={control}
                                                defaultValue=""
                                                className='form-select'
                                                rules={{
                                                    required: true,
                                                    message: 'Name is required',
                                                }}
                                                render={({ field }) => <select className='form-select' name="state" id='state' {...field}>
                                                    <option value=''>Select State</option>
                                                    {stateList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                                </select>}
                                            />
                                            {errors?.state && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>

                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Zip / Postal Code <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='zipcode' minLength='5' maxLength='6' className="form-control" id="zipcode" placeholder="Enter Zip/Postal Code"
                                                {...register('zipcode', {
                                                    required: true,
                                                    message: 'Name is required', minLength: 5, maxLength: 6,
                                                    validate: (value) => value.trim() !== ''
                                                })}
                                                onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && getValues()?.country == 'Canada' ? restrictSpecialChar(e) : restrictInputValues(e)}
                                                onPaste={(e) => {
                                                    e.preventDefault()
                                                    return false
                                                }}
                                            />
                                            {errors?.zipcode && <span className="text-danger small">This field is required</span>}
                                            {errors?.zipcode?.type === 'minLength' && <span className="text-danger small">{isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed'}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* ─── OTP SECTION ─────────────────────────────────────── */}
                                <div className="row mt-3">
                                    <div className="col-12">
                                        {otpSent && (
                                            <div className="border rounded p-3 bg-light">
                                                <label className="form-label text-primary fw-bold mb-1">
                                                    <i className="fa fa-shield me-1"></i>
                                                    Enter Verification Code <span className="text-danger">*</span>
                                                </label>

                                                <input
                                                    type="text"
                                                    id="signup_otp"
                                                    name="signup_otp"
                                                    className="form-control"
                                                    placeholder="Enter 6-digit OTP"
                                                    maxLength={6}
                                                    value={otp}
                                                    onChange={(e) => handleOtpChange(e.target.value)}
                                                    onKeyPress={(e) => restrictInputValues(e)}
                                                    inputMode="numeric"
                                                    autoFocus
                                                    style={{ maxWidth: '200px', letterSpacing: '0.2em', fontWeight: 'bold' }}
                                                />

                                                <div className="d-flex align-items-center justify-content-between mt-2">
                                                    <small className="text-muted">
                                                        OTP sent to your {otpSentFor?.method === 'email' ? 'email' : 'phone number'}
                                                    </small>
                                                    {otpLoading
                                                        ? <span className="small text-muted">Sending OTP...</span>
                                                        : canResend
                                                            ? <span className="small text-primary cursor" role="button" onClick={handleResendOtpClick}>Resend OTP</span>
                                                            : resendCooldown > 0
                                                                ? <span className="small text-muted">Resend OTP in {resendCooldown}s</span>
                                                                : resendLimitReached
                                                                    ? <small className="text-danger">Max resend limit reached</small>
                                                                    : null
                                                    }
                                                </div>

                                                {otpError && (
                                                    <span className="text-danger small mt-1 d-block">
                                                        <i className="fa fa-exclamation-circle me-1"></i>{otpError}
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                        {!otpSent && otpError && (
                                            <span className="text-danger small">
                                                <i className="fa fa-exclamation-circle me-1"></i>{otpError}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {/* ─────────────────────────────────────────────────────── */}
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="mb-5">
                            <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBackButton} ><i className="fa fa-angle-left"></i> Back To Login</button>
                            {/* ===== reCAPTCHA: disabled when not ready ===== */}
                            <Button type="submit" className="btn btn-primary" disabled={otpLoading || isLoading || !isReady || (otpSent && otp.length !== 6)}>
                                <div className='d-flex aling-items-center'>
                                    <span>{otpSent ? 'Submit' : 'Send OTP'}</span> <span className='ms-2'>
                                        {(otpLoading || isLoading) ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div>
                            </Button>
                        </Modal.Footer>
                    </form>
                }
            </Modal>
            {/* <ToastContainer /> */}
        </>
    )
}
ModalLogin.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    setShow: PropTypes.func,
    show: PropTypes.bool,
    loaderSing: PropTypes.bool,
    notify: PropTypes.func,
    useFor: PropTypes.number,
    stateData: PropTypes.array,
    countryData: PropTypes.array,
    partnerDetails: PropTypes.object,
}

ModalLogin.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    setShow: noop,
    show: false,
    loaderSing: false,
    notify: noop,
    useFor: '0',
    stateData: EMPTY_ARRAY,
    countryData: EMPTY_ARRAY,
    partnerDetails: EMPTY_OBJECT,

}

function mapStateToProps({ loginReducer, vehicleListReducer }) {
    return {
        loaderSing: loginReducer?.loader,
        stateData: vehicleListReducer?.data?.state,
        countryData: vehicleListReducer?.data?.country
    }
}
export default connect(mapStateToProps)(ModalLogin)